import movieState from '@/entity/module/movie';
import apiHttpHelper, { ResponseBasic } from '@/common/ApiHelper';
import movie from '@/entity/module/movie/movieAPi';
import { dispatchProps } from '@/entity';
export default {
  namespace: 'movie', // 表示在全局 state 上的 key
  state: {
    title: 'test',
    serverTime: '',
    dataParams: null
  }, // 状态数据
  // 管理同步方法，必须是纯函数
  reducers: {
    HelloWord(state = movieState, { type, payload }: dispatchProps) {
      return {
        ...state,
        title: payload.title
      };
    },
    setUserDataParams(state = movieState, { type, payload }: dispatchProps) {
      return {
        ...state,
        dataParams: payload
      };
    },
    GetServerTime(state = movieState, { payload }: dispatchProps) {
      const data = payload.Data;
      const serverTime = data.year + '-' + data.month + '-' + data.day;
      return {
        ...state,
        serverTime
      };
    }
  },
  // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Generator
  // 管理异步操作，采用了 generator 的相关概念
  effects: {
    *GetNowTime({ payload }, { call, put, select }) {
      // 获取 state 中的值
      // const { title } = yield select(state => { state.movie });
      // 接口入参
      // const params = { ...payload };
      const data = yield call(movie.GetUrlTime);
      // 请求成功之后，调用 reducer 同步方法更新 state
      yield put({
        // 调用当前 model 的 action 不需要添加 namespace
        type: 'GetServerTime',
        payload: data
      });
    }
  },
  subscriptions: {} // 订阅数据源
};
